import React from 'react';
import { Link } from 'gatsby';

const CustomLink = ({ children, url, classes }) => {
	if (url.includes('http')) {
		return (
			<a href={url} className={classes} target='_blank' rel='noreferrer'>
				{children}
			</a>
		);
	}
	if (url.includes('mailto')) {
		return (
			<a href={url} className={classes} target='_blank' rel='noreferrer'>
				{children}
			</a>
		);
	} else {
		return (
			<Link to={url} className={classes} activeClassName='active'>
				{children}
			</Link>
		);
	}
};
export default CustomLink;
